import { createFileRoute, redirect } from "@tanstack/react-router";
import type { UserActor } from "@corpuscomplete/core/actor";
import { AdminShell } from "@corpuscomplete/web/modules/admin/components/admin-shell";
import { getCachedSession } from "../auth/client";
import * as Sentry from "@sentry/react";

/** Admin layout guard: authenticated admin-only access with fallback redirects. */
export const Route = createFileRoute("/_admin")({
  component: AdminShell,
  beforeLoad: async ({ location }) => {
    const { data } = await getCachedSession();
    if (!data) {
      Sentry.setUser(null);
      throw redirect({
        to: "/login",
        search: {
          redirect: location.href,
        },
      });
    }
    if (data.user.role !== "admin") {
      throw redirect({ to: "/home" });
    }
    Sentry.setUser({ id: data.user.id });
    const actor: UserActor = { type: "user", userId: data.user.id };
    return { session: data.session, user: data.user, actor };
  },
});
